import { createNavigation } from 'next-intl/navigation';
import { routing } from './routing';

/**
 * Locale-aware navigation primitives. Use these in place of next/link and
 * next/navigation everywhere internal — they auto-prepend the active locale
 * prefix when it's needed (i.e. anything other than the default locale under
 * `localePrefix: 'as-needed'`), so `<Link href="/login">` keeps a Spanish
 * user on /es/login instead of bouncing them back to English.
 *
 * External links, mailto:, tel:, and asset paths can keep using bare anchors —
 * these helpers are only for routes inside this app.
 */
export const { Link, useRouter, usePathname, redirect, getPathname, permanentRedirect } = createNavigation(routing);
